import Vue from "vue";
import Router from "vue-router";
import JobOverview from "./views/JobsOverviewPage.vue";
import JobPage from "./views/JobPage.vue";
// import JobPage from "./views/JobPage.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "",
  routes: [
    {
      // vacature overzicht pagina
      path: "/:jobsOverviewUrl",
      name: "JobOverview",
      component: JobOverview
    },
    {
      // vacature detail pagina
      path:
        process.env.NODE_ENV === "development"
          ? "/vacatures/:urlSegment"
          : "/:jobsOverviewUrl/:urlSegment",
      name: "Job",
      component: JobPage
    },
    // {
    //   // uitgelichte vacatures pagina
    //   path: "/jobsOverviewUrl/:brand",
    //   name: "JobOverview",
    //   component: JobOverview
    // }
  ],

  // https://router.vuejs.org/guide/advanced/scroll-behavior.html#async-scrolling
  scrollBehavior() {
    // return desired position
    return { x: 0, y: 0 };
  }
});
